import React from "react";
// import Alert from "react-bootstrap/Alert";
import { Col, Container, Row } from "react-bootstrap";
import "../../../styles/hydiene-system/hydiene.css";
import HelmetWrapper from "../../../HelmetWrapper";
import WelcomeUser from "../../Open-pages/user/WelcomeUser";
import Notifications from "../../push-notifications/Notifications";
import TaskListings from "./TaskListings";

const SubmittedTaskListings = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  return (
    <HelmetWrapper title="WTF: Daily Operation Checklist">
      <Container className="bg-cloud-k px-50px gobal-container hui-submitted-tasks-container" fluid>
        <Row>
          <Col>
            {isCustom && (
              <div className="mt30">
                <WelcomeUser userName={userInfoData?.name} />

                {userInfoData && !isIOS() && (
                  <Notifications authData={userInfoData} />
                )}

                {/* {isNotificationDenied === "denied" && (
                  <Alert variant={"danger"} className="mt30">
                    Notification permission is denied. Unable to display desktop
                    notifications.
                  </Alert>
                )} */}
              </div>
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <TaskListings userInfoData={userInfoData} />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default SubmittedTaskListings;
